export const mapStateToProps = state => ({
  hasMeetingStarted: state.meeting.hasMeetingStarted,
  token: state.auth.token,
});

export const mapDispatchToProps = () => ({

});
